<template>
  <div id="app">    
    <pg-fill-modal ref="rawModal" v-if="showRaw" @click="showRaw = false">
      <div class="row" slot="body">
        <pre>{{ rawData }}</pre>
      </div>
    </pg-fill-modal>
    <pg-sidepanel :brand="brand" v-if="loggedIn">
      <pg-sidepanel-item title="Organizations" :active="$route.path == '/'" href="#/" cls="m-t-50"></pg-sidepanel-item>      
    </pg-sidepanel>
    <div class="page-container full-height" v-if="loggedIn">
      <pg-navbar :brand="brand" :logout="logout"></pg-navbar>
      <div class="page-content-wrapper full-height">
        <div class="content full-height">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <pg-login :brand="brand" v-if="!loggedIn" v-on:login="onLogin"></pg-login>
  </div>    
</template>

<script>

import Search from './search.vue';
import QuickView from './quick_view.vue';

export default {
  components: {    
    Search,
    QuickView
  },
  data: () => ({
   user: {},
   showRaw: false,
   rawData: {},
   loggedIn: false,
   brand: "<strong>Proximi</strong>.io <strong>Control</strong>"
  }),  
  created() {
    this.$bus.$on('raw', (data) => {
      this.showRaw = true;
      this.rawData = data;
      this.$nextTick(() => {
        this.$refs.rawModal.show()
      })
    });

    this.$bus.$on('auth:logged_in', (user) => {
      this.user = user;
      this.loggedIn = true;
    });

    this.$bus.$on('auth:login_failure', (user) => {
      this.user = {};
      this.loggedIn = false;
    });

    if (this.$auth.isLoggedIn()) {
      this.user = this.$auth.current;
      this.loggedIn = true;      
    }

    this.$bus.$on('auth:logged_out', () => {
      this.user = {};
      this.loggedIn = false;
    });
    
    window.App = this;
  },  
  mounted() {        
    window.Pages.init();
  },
  methods: {
    isAdmin() {
      return this.user.email === 'devs@proximi.io'
    },
    onLogin(credentials) {
      this.$auth.login(credentials.email, credentials.password);
    },
    logout() {
      this.$auth.logout();
    }
  }
}
</script>

<style>

#app {
  width: 100%;
  height: 100%;
}

.w-30 {
  width: 30px;
}

.w-100 {
  width: 100px;
}

.w-130 {
  width: 130px;
}

.align-center {
  text-align: center;
}

a.link, a.router-link {
  cursor: pointer;
  font-weight: 600;
  font-size: 100%;
  line-height: 17px;  
  font-family: "Segoe UI",Arial,sans-serif;
  color: #3B4752;
}

table tr td, table tr td a {
  font-size: 89%;
}

table tr td.actions {
  padding-top: 12px;
  padding-bottom: 0px;
}

table tr th.v-align-b, table tr td.v-align-b {
  vertical-align: bottom;
}

table tr th.v-align-t, table tr td.v-align-t {
  vertical-align: top;
}

.panel-heading .dropdown ul li a, .panel-heading .dropdown-menu li a {
  opacity: 1;
}

.box-option {
  cursor: pointer;
}
.box-title {
  margin-left: 10px;
}

#app .page-sidebar .sidebar-menu .menu-items > li > a > .title {
  text-overflow: clip;
  width: 100%;
  font-weight: normal;
}

.pointer {
  cursor: pointer;
}

.no-overflow {
  text-overflow: clip !important;
}

.panel-hoverize {
  transition: all 0.5s ease;
}

.panel-hoverize:hover {
  box-shadow: 0px 0px 10px rgba(78, 177, 244, 0.8);
  cursor: pointer;
}

label.col-sm-3.control-label {
  font-size: 14px;
  color: black;
  font-weight: 600;
}

.fs-24 {
  font-size: 24px !important;
}

.fs-18 {
  font-size: 18px !important;
} 

.fs-12 {
  font-size: 12px !important;
}

.vtop {
  vertical-align: top;
}

li.divider {
  width: 100%;
  height: 1px;
  background-color: #eaeaea;
  margin-bottom: 15px;
  margin-top: 15px;
}

.modal.fade.fill-in.in {
  background-color: rgba(255, 255, 255, 0.95);
}

.scroll-y {
  overflow-y: scroll;
}

.border-top {
  border-top: 1px solid #f3f3f3; 
}

.list-wrapper {

}
</style>



// WEBPACK FOOTER //
// App.vue?bef8b8b6